import {
  CurrencyArea,
  getPrimaryTagOverrides,
  IItineraryTagOverrides,
  resolveDefaultCurrency,
  setCurrencyChoice,
} from "@eventr/common";
import { bs } from "./bound.store";
import { getItineraryMapByID } from "./itineraryState/itineraryMap.slice";

/** The selected itinerary's primary tag overrides. Guests never receive `itinTags`, so they get none. */
export const selectedItineraryTagOverrides = (): IItineraryTagOverrides | undefined =>
  getPrimaryTagOverrides(getItineraryMapByID(bs().selectedItinID)?.tags, bs().orgConfig.itinTags ?? []);

/** The currency a selector in `area` starts on for the selected org and itinerary. */
export const resolveAreaCurrency = (area: CurrencyArea, countryCode?: string): string =>
  resolveDefaultCurrency({
    area,
    orgConfig: bs().orgConfig,
    tagOverrides: selectedItineraryTagOverrides(),
    orgId: bs().selectedOrg?.name,
    countryCode,
  });

/** Records the user's pick in `area` for the selected org. No org, no pick. */
export const pickAreaCurrency = (area: CurrencyArea, code: string): void => {
  const orgId = bs().selectedOrg?.name;
  if (orgId) setCurrencyChoice(area, code, orgId);
};
